import { render, staticRenderFns } from "./PersonBonusCard.vue?vue&type=template&id=220d8fca"
import script from "./PersonBonusCard.vue?vue&type=script&lang=js"
export * from "./PersonBonusCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports